import { render, staticRenderFns } from "./bill-form.vue?vue&type=template&id=3711870c&scoped=true"
import script from "./bill-form.vue?vue&type=script&lang=js"
export * from "./bill-form.vue?vue&type=script&lang=js"
import style0 from "./bill-form.vue?vue&type=style&index=0&id=3711870c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711870c",
  null
  
)

export default component.exports